import { render, staticRenderFns } from "./DetalhesMaterial.vue?vue&type=template&id=61477a08&scoped=true&lang=pug"
import script from "./DetalhesMaterial.vue?vue&type=script&lang=js"
export * from "./DetalhesMaterial.vue?vue&type=script&lang=js"
import style0 from "./DetalhesMaterial.vue?vue&type=style&index=0&id=61477a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61477a08",
  null
  
)

export default component.exports